<div class="alert text-center"> Message</div>
<div id="list-message" class="content scaffold-list" role="main">
    <div class="row">

        <div class="col-sm-3" *ngIf="authService.isGuardian()">
            <app-side-bar-guardian-home [guardian]="guardian"></app-side-bar-guardian-home>
        </div>
        <div class="col-sm-3" *ngIf="authService.isStudent()">
            <app-student-gift-area *ngIf="student.server_student_id!=0" [student]="student"></app-student-gift-area>
        </div>
        <div class="col-sm-9">
            <table class="table table-stripped">
                <tr><td>From</td><td>{{message.fromUserName}}</td></tr>
                <tr><td>To</td><td>{{message.fromUserName}}</td></tr>
                <tr><td>Title</td><td>{{message.title}}</td></tr>
                <tr><td>Body</td><td>{{message.body}}</td></tr>
                <tr><td>Date Created</td><td>{{message.datecreated}}</td></tr>
            </table>

        </div>
</div>
</div>
